<template>
    <div class="whole-step-container no-form-text">
        <card-container 
            :title="titleByLanguage"
        >
            <template #customBtn>
                <div class="select-option-containers">
                    <div class="language-select-area">
                        {{ $t('workorder_form_language_select') }}
                        <a-select
                            style="width: 120px"
                            @change="uiHandler.handleLanguageChange"
                            :default-value="commonEnum.language.KO"
                            :value="language"
                            :not-found-content="null"
                        >
                            <a-select-option :value="commonEnum.language.KO">
                                <span class="select-option-content">
                                    🇰🇷
                                    {{ $t('workorder_form_lang_korean') }}
                                </span>
                            </a-select-option>
                            <a-select-option :value="commonEnum.language.ZH">
                                <span class="select-option-content">
                                    🇨🇳
                                    {{ $t('workorder_form_lang_chinese') }}
                                </span>
                            </a-select-option>
                            <a-select-option :value="commonEnum.language.EN">
                                <span class="select-option-content">
                                    🇺🇸
                                    {{ $t('workorder_form_lang_english') }}
                                </span>
                            </a-select-option>
                        </a-select>
                    </div>
                    <div class="language-select-area" v-if="supportMsgChannel.length > 1">
                        {{ $t('workorder_form_send_channel_select') }}
                        <a-select
                                style="width: 120px"
                                @change="uiHandler.handleSendChannelChange"
                                :default-value="supportMsgChannel[0]"
                                :value="sendChannel"
                                :not-found-content="null"
                            >
                            <a-select-option 
                                v-for="channel in supportMsgChannel" 
                                :key="channel"
                                :value="commonEnum.sendChannel[channel]"
                            >
                                <span class="select-option-content">
                                    <i :class="channelConfig[channel].icon" 
                                    :style="channelConfig[channel].style" />
                                    {{ getChannelName(channel) }}
                                </span>
                            </a-select-option>
                        </a-select>
                    </div>
                </div>
            </template>
            <a-form
                ref="formRef"
                :model="customerInfo"
                :rules="rules"
                :layout="formLayout"
            >
                <div class="step-1-customer issue-card-content">
                    <div class="left-container">
                        <!-- 이메일 입력 필드 (이메일 채널일 때만 표시) -->
                        <a-form-item
                            v-if="sendChannel === commonEnum.sendChannel.EMAIL"
                            name="email"
                            ref="email"
                            :colon="false"
                            :validate-status="'success'"
                            :help="''"
                        >
                            <template #label>
                                <row-with-label
                                    :label-title="$t('workorder_form_email')"
                                    :is-required="true"
                                />
                            </template>
                            <a-input 
                                id="email-input" 
                                placeholder="example@email.com" 
                                :maxlength="100"
                                :tabindex="1"
                                :value="customerInfo.email"
                                @input="uiHandler.handleCustomerEmailChange"
                                ref="emailInput"
                                type="email"
                            />
                        </a-form-item>
                        
                        <!-- 전화번호 입력 필드 (항상 표시) -->
                        <a-form-item
                            name="mobile"
                            ref="mobile"
                            :colon="false"
                            :validate-status="'success'"
                            :help="''"
                        >
                            <template #label>
                                <row-with-label
                                    :label-title="$t('workorder_form_contact')"
                                    :is-required="false"
                                />
                            </template>
                            <div class="mobile-input-wrap">
                                <a-form-item-rest>
                                    <a-select 
                                        v-model:value="customerInfo.countryCode"
                                        @change="uiHandler.handleCountryCodeChange"
                                        class="select-country-code"
                                        :not-found-content="null"
                                    >
                                        <a-select-option 
                                            v-for="option in countryCodeList" 
                                            :key="option.value" 
                                            :value="option.value"
                                        >
                                            {{ option.label }}
                                        </a-select-option>
                                        <a-select-option value="ETC">{{ $t('workorder_form_direct_input') }}</a-select-option>
                                    </a-select>
                                </a-form-item-rest>
                                <a-input 
                                    id="phone-number-input" 
                                    placeholder="010-0000-0000" 
                                    :maxlength="20"
                                    :tabindex="1"
                                    :value="customerInfo.mobile"
                                    @input="uiHandler.handleCustomerMobileChange"
                                    ref="mobileInput"
                                    type="text"
                                    inputmode="numeric"
                                />
                            </div>
                        </a-form-item>
                        <a-form-item 
                            name="name"
                            ref="name"
                            :colon="false"
                            :validate-status="'success'"
                            :help="''"
                        >
                            <template #label>
                                <row-with-label
                                    :label-title="$t('workorder_form_name')"
                                    :is-required="true"
                                />
                            </template>
                            <a-select
                                id="step-1-name"
                                v-model:value="customerInfo.name"
                                show-search
                                :tabindex="2"
                                style="width: 100%; min-height: 40px !important;"
                                :placeholder="$t('workorder_form_name_placeholder')"
                                :default-active-first-option="false" 
                                :show-arrow="false" 
                                :filter-option="false"
                                :not-found-content="null"
                                @input="uiHandler.handleInputCustomerName"
                                @search="uiHandler.getCustomerListByName($event)"
                                @change="uiHandler.handleOnChangeCustomerNameInfo"
                                :searchValue="customerInfo.name"
                                ref="nameInput"
                            >
                                <a-select-option
                                v-for="(item, index) in nameDropBoxData"
                                :value="item.name+item.mobile+item.gender"
                                :key="index"
                                >
                                <div class="name-text-wrap">
                                    <div class="name-part">{{ item.name }}</div>
                                    <div class="mobile-part">{{ formatHandler.phoneNumberFormatter(item.mobile) }}</div>
                                    <div class="gender-part">{{ formatHandler.computeGender(item.gender) }}</div>
                                    <div class="birth-part">{{ item.birth }}</div>
                                </div>
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                    </div>
                    <div class="right-container">
                        <a-form-item
                            name="doctor"
                            ref="doctor"
                            :colon="false"
                            v-if="showDoctorInput"
                            :validate-status="'success'"
                            :help="''"
                        >
                            <template #label>
                                <row-with-label
                                    :label-title="$t('workorder_form_surgeon')"
                                    :is-required="false"
                                />
                            </template>
                            <doctor-select
                                :language="language"
                                :value="customerInfo.doctor"
                                :doctor-list="doctorList"
                                @update:value="uiHandler.handleDoctorChange"
                                :is-custom-doctor="isCustomDoctor"
                                @update:is-custom-doctor="uiHandler.handleCustomDoctorChange"
                            />
                        </a-form-item>
                        <!-- 차트번호 필드 추가 (연락처 오른쪽) -->
                        <a-form-item
                            v-if="!showDoctorInput"
                            name="chartNumber"
                            ref="chartNumber"
                            :colon="false"
                            :validate-status="'success'"
                            :help="''"
                        >
                            <template #label>
                                <row-with-label
                                    :label-title="$t('workorder_form_chart_number')"
                                    :is-required="false"
                                />
                            </template>
                            <a-input
                                :placeholder="$t('workorder_form_chart_number_placeholder')"
                                :maxlength="50"
                                :value="customerInfo.chartNumber"
                                @input="uiHandler.handleChartNumberChange"
                                type="text"
                            />
                        </a-form-item>
                        <a-form-item
                            name="gender"
                            ref="gender"
                            :colon="false"
                            :validate-status="'success'"
                            :help="''"
                        >
                            <template #label>
                                <row-with-label
                                    :label-title="$t('workorder_form_gender')"
                                    :is-required="false"
                                />
                            </template>
                            <gender-select
                                :gender="customerInfo.gender"
                                :language="language"
                                @handle-gender-change="handleGenderChange"
                            />
                        </a-form-item>
                    </div>
                </div>
                <div class="step-1-customer issue-card-content">
                    <div class="left-container">
                        <a-form-item
                            name="birth"
                            ref="birth"
                            :colon="false"
                            :validate-status="'success'"
                            :help="''"
                        >
                            <template #label>
                                <row-with-label
                                    :label-title="$t('workorder_form_birthdate')"
                                    :is-required="false"
                                />
                            </template>
                            <a-input 
                                placeholder="0000/00/00" 
                                :maxlength="10"
                                :tabindex="3"
                                :value="birthInputValue"
                                @input="formatDate($event, 'birthday')"
                                type="text"
                                inputmode="numeric"
                            />
                        </a-form-item>
                    </div>
                    <div class="right-container">
                        <a-form-item
                            name="surgeryDate"
                            ref="surgeryDate"
                            :colon="false"
                            :validate-status="'success'"
                            :help="''"
                        >
                            <template #label>
                                <row-with-label
                                    :label-title="$t('workorder_form_surgery_date')"
                                    :is-required="false"
                                />
                            </template>
                            <a-input 
                                type="text"
                                inputmode="numeric"
                                placeholder="0000/00/00" 
                                :maxlength="10"
                                :tabindex="9" 
                                :value="surgeryInputValue" 
                                @input="formatDate($event, 'surgery')"
                            />
                        </a-form-item>
                    </div>
                </div>
            </a-form>
            <div class="step-1-customer issue-card-content" style="padding-bottom: 20px;">
                <div class="left-container">
                    <div class="date-picker-wrap issue">
                        <div class="datepicker-item">
                            <div class="year-month-wrap">
                                <div class="year-wrap birth-year-wrap">
                                    <button 
                                        class="year-item"
                                        v-for="year in yearList"
                                        :key="year"
                                        :value="year"
                                        @click="uiHandler.handleBirthYearClick(year)"
                                        :class="{ selected: uiHandler.checkBirthYearSelected(year) }"
                                        :id="`birth-year-${year}`"
                                    >
                                        {{ year }}
                                    </button>
                                </div>
                                <div class="month-wrap birth-month-wrap">
                                    <button 
                                        class="month-item"
                                        v-for="month in monthList"
                                        :key="month"
                                        :value="month"
                                        @click="uiHandler.handleBirthMonthClick(month)"
                                        :class="{ selected: uiHandler.checkBirthMonthSelected(month) }"
                                        :id="`birth-month-${month}`"
                                    >
                                        {{ month }}
                                    </button>
                                </div>
                            </div>
                            <VueDatePicker
                                :select-text="$t('workorder_form_select')"
                                :cancel-text="$t('workorder_form_cancel')"
                                validate vertical
                                locale="ko-KR"
                                inline
                                text-input
                                inline-with-input
                                auto-apply
                                :month-change-on-scroll="false"
                                v-model="customerInfo.birth"
                                format="yyyy/MM/dd"
                                @update:model-value="handleBirthDatePickerChange"
                            />
                        </div>
                    </div>
                </div>
                <div class="right-container">
                    <div class="date-picker-wrap issue">
                        <div class="datepicker-item">
                            <div class="year-month-wrap">
                                <div class="year-wrap surgery-year-wrap">
                                    <button 
                                        class="year-item"
                                        v-for="year in yearList"
                                        :key="year"
                                        :value="year"
                                        @click="uiHandler.handleSurgeryYearClick(year)"
                                        :class="{ selected: uiHandler.checkSurgeryYearSelected(year) }"
                                        :id="`surgery-year-${year}`"
                                    >
                                        {{ year }}
                                    </button>
                                </div>
                                <div class="month-wrap surgery-month-wrap">
                                    <button 
                                        class="month-item"
                                        v-for="month in monthList"
                                        :key="month"
                                        :value="month"
                                        @click="uiHandler.handleSurgeryMonthClick(month)"
                                        :class="{ selected: uiHandler.checkSurgeryMonthSelected(month) }"
                                        :id="`surgery-month-${month}`"
                                    >
                                        {{ month }}
                                    </button>
                                </div>
                            </div>
                            <VueDatePicker
                                :select-text="$t('workorder_form_select')"
                                :cancel-text="$t('workorder_form_cancel')"
                                validate vertical
                                locale="ko-KR"
                                inline
                                text-input
                                inline-with-input
                                auto-apply
                                :month-change-on-scroll="false"
                                v-model="customerInfo.surgeryDate"
                                format="yyyy/MM/dd"
                                @update:model-value="handleSurgeryDatePickerChange"
                            />
                        </div>
                    </div>
                </div>
            </div>

        </card-container>
        <!-- <agreements-container 
            :agreements="agreements" 
            @agreements-changed="uiHandler.handleAgreementsChange"
            :target-language="language"
        /> -->
    </div>
    <country-code-modal
        :showModal="modals.countryCodeModal.show"
        @closeModal="uiHandler.modalHandler"
        @emitCountryCode="uiHandler.handleEmitCountryCode"
        :currentCountryCode="tempCountryCode"
    />
</template>
<script>
import CardContainer from './CardContainer.vue';
import AgreementsContainer from './AgreementsContainer.vue';
import RowWithLabel from '@/views/components/RowWithLabel';
import GenderSelect from './GenderSelect.vue';
import EmptyRow from './EmptyRow.vue';
import DoctorSelect from './DoctorSelect.vue';
import CountryCodeModal from './CountryCodeModal.vue';
import issueCertificateCommonApis from './api/common';
import dayjs from 'dayjs';

import {
    GenderEnum,
} from '@/enums/common.enums';
import {
    phoneNumberFormatter,
    oneBtnDialog,
    logging,
} from '@/utils/utils';
import { 
    issueUtils,
} from './utils/utils';
import { commonEnum } from './enums/common';

export default {
    name: 'CustomerInfoForm',
    components: {
        CardContainer,
        AgreementsContainer,
        RowWithLabel,
        GenderSelect,
        EmptyRow,
        DoctorSelect,
        CountryCodeModal,
    },
    emits: [
        'update:modelValue',
        'update:customerInfo',
        'update:sendChannel',
        'update:language',
        'update:canLeavePage',
        'focus-on-next-step-button',
        'update:isCustomDoctor'
    ],
    data() {
        return {
            uiHandler: this.createUiHandler(),
            commonApiHandler: this.createApiHandler().common(),
            validationHandler: this.createValidationHandler(),
            formatHandler: this.createFormatter(),
            issueUtils: issueUtils(),
            commonEnum,
            yearList: [],
            monthList: [],
            birthInputValue: '',
            surgeryInputValue: '',
            agreements: [],
            nameDropBoxData: [],
            rules: {
                mobile: [],
                name: [],
                gender: [],
                birth: [],
                surgeryDate: [],
            },
            tempCountryCode: '',
            modals: {
                countryCodeModal: {
                    show: false,
                },
            },
        }
    },
    props: {
        windowInnerWidthGreaterThan1000: {
            type: Boolean,
            default: false,
        },
        showDoctorInput: {
            type: Boolean,
            default: false,
        },
        isCustomDoctor: {
            type: Boolean,
            default: false,
        },
        doctorList: {
            type: Array,
            default: [],
        },
        sendChannel: {
            type: String,
            default: commonEnum.sendChannel.KAKAOTALK,
        },
        language: {
            type: String,
            default: commonEnum.language.KO,
        },
        countryCodeList: {
            type: Array,
            default: [],
        },
        modelValue: {
            type: Object,
            required: true,
        },
        supportMsgChannel: {
            type: Array,
            default: [],
        },
        channelConfig: {
            type: Object,
            default: {},
        },
    },
    computed: {
        formLayout() {
            return this.windowInnerWidthGreaterThan1000 ? 'horizontal' : 'vertical';
        },
        titleByLanguage() {
            return this.$t('workorder_form_patient_info_title');
        },
        customerInfo: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            }
        },
    },
    mounted() {
        this.uiHandler.init();
        this.uiHandler.focusOnMobileInput();
    },
    methods: {
        logging: logging().exceptProd,
        /*
        
        자식 컴포넌트에서 emit된걸 받으려면 uiHandler에서 처리하지 못함
        methods에 넣어놔야 처리 가능
        
        */
        handleGenderChange(value) {
            this.uiHandler.handleCustomerInfoChange('gender', value);
        },
        
        // locale 함수 정의
        getLocaleByLanguageCode(language) {
            return 'ko-KR'; // 한국어로 고정
        },

        // 채널 이름 가져오기
        getChannelName(channel) {
            switch(channel) {
                case 'KAKAOTALK': return this.$t('workorder_form_channel_kakaotalk');
                case 'WECHAT': return this.$t('workorder_form_channel_wechat');
                case 'EMAIL': return this.$t('workorder_form_channel_email');
                default: return channel;
            }
        },

        // 달력 날짜 선택 핸들러들
        handleBirthDatePickerChange(date) {
            if (!date) {
                this.customerInfo.birth = null;
                this.birthInputValue = '';
                return;
            }
            const text = dayjs(date).format('YYYY/MM/DD');
            this.customerInfo.birth = text;
            this.birthInputValue = text;
            
            this.uiHandler.scrollToSelectedBirthYear();
            this.uiHandler.scrollToSelectedBirthMonth();
        },

        handleSurgeryDatePickerChange(date) {
            if (!date) {
                this.customerInfo.surgeryDate = null;
                this.surgeryInputValue = '';
                return;
            }
            const text = dayjs(date).format('YYYY/MM/DD');
            this.customerInfo.surgeryDate = text;
            this.surgeryInputValue = text;
            
            this.uiHandler.scrollToSelectedSurgeryYear();
            this.uiHandler.scrollToSelectedSurgeryMonth();
        },
        
        // 부모 컴포넌트에서 호출할 검증 메서드 (Step2 호환성을 위해)
        async validateForm() {
            return await this.validationHandler.validateData();
        },

        // 부모 컴포넌트에서 호출할 데이터 가져오기 메서드 (Step2 호환성을 위해)
        getFormData() {
            return {
                ...this.customerInfo,
                agreements: this.agreements,
                chartNumber: this.customerInfo.chartNumber || ''
            };
        },

        // 날짜 입력 포맷 함수
        formatInputToDate(input) {
            const onlyNumbers = input.replace(/\D/g, ''); // 숫자만 추출

            if (onlyNumbers.length <= 4) {
                return onlyNumbers;
            } else if (onlyNumbers.length <= 6) {
                let year = onlyNumbers.slice(0, 4);
                let month = onlyNumbers.slice(4);

                // 월 검증
                if (parseInt(month, 10) > 12) {
                    month = '12';
                }

                return `${year}/${month}`;
            } else {
                let year = onlyNumbers.slice(0, 4);
                let month = onlyNumbers.slice(4, 6);
                let day = onlyNumbers.slice(6, 8);

                // 월과 일 검증
                if (parseInt(month, 10) > 12) {
                    month = '12';
                }
                if (parseInt(day, 10) > 31) {
                    day = '31';
                }

                return `${year}/${month}/${day}`;
            }
        },

        // 날짜 포맷 함수 (직접 정의)
        formatDate(event, type) {
            const result = this.formatInputToDate(event.target.value);
            event.target.value = result;
            if(type === 'birthday') {
                this.birthInputValue = result;
                if(result.length === 10) {
                    this.customerInfo.birth = result;
                    
                    this.uiHandler.scrollToSelectedBirthYear();
                    this.uiHandler.scrollToSelectedBirthMonth();
                } else if(result.length === 0) {
                    this.customerInfo.birth = result;
                }
            } else {
                this.surgeryInputValue = result;
                if(result.length === 10) {
                    this.customerInfo.surgeryDate = result;

                    this.uiHandler.scrollToSelectedSurgeryYear();
                    this.uiHandler.scrollToSelectedSurgeryMonth();
                } else if(result.length === 0) {
                    this.customerInfo.surgeryDate = result;
                }
            }
        },

        createFormatter() {
            return {
                formatInputToDate: this.formatInputToDate,
                phoneNumberFormatter,
                formatBirthdayVueDatepicker: (date) => {
                    if (!date) return '';
                    const text = this.issueUtils.formatDayForVueDatepicker(date);
                    this.customerInfo.birth = text;
                    this.birthInputValue = text;

                    this.uiHandler.scrollToSelectedBirthYear();
                    this.uiHandler.scrollToSelectedBirthMonth();
                    return text;
                },
                formatSurgeryDateVueDatepicker: (date) => {
                    if (!date) return '';
                    const text = this.issueUtils.formatDayForVueDatepicker(date);
                    this.customerInfo.surgeryDate = text;
                    this.surgeryInputValue = text;

                    this.uiHandler.scrollToSelectedSurgeryYear();
                    this.uiHandler.scrollToSelectedSurgeryMonth();
                    return text;
                },
                computeGender: (input) => {
                    if(!input) return '';
                    if(input === GenderEnum.MALE)  return '남'; 
                    else if(input === GenderEnum.FEMALE) return '여'; 
                },
                formatDate: (event, type) => {
                    const result = this.formatHandler.formatInputToDate(event.target.value);
                    event.target.value = result;
                    if(type === 'birthday') {
                        this.birthInputValue = result;
                        if(result.length === 10) {
                            this.customerInfo.birth = result;
                            
                            this.uiHandler.scrollToSelectedBirthYear();
                            this.uiHandler.scrollToSelectedBirthMonth();
                        } else if(result.length === 0) {
                            this.customerInfo.birth = result;
                        }
                    } else {
                        this.surgeryInputValue = result;
                        if(result.length === 10) {
                            this.customerInfo.surgeryDate = result;

                            this.uiHandler.scrollToSelectedSurgeryYear();
                            this.uiHandler.scrollToSelectedSurgeryMonth();
                        } else if(result.length === 0) {
                            this.customerInfo.surgeryDate = result;
                        }
                    }
                },
            }
        },
        createUiHandler() {

            return {
                init: async () => {
                    await this.uiHandler.generateYearAndMonths();
                    this.uiHandler.scrollToSelectedBirthYear();
                    this.uiHandler.scrollToSelectedBirthMonth();
                    this.uiHandler.scrollToSelectedSurgeryYear();
                    this.uiHandler.scrollToSelectedSurgeryMonth();
                    /*
                    
                        고객층이 대부분 1970년대생이라 년/월 스크롤은 1970/01/01로
                        하지만 생년월일에 1970년도라고 나와 있으면 본인 생년이 아니라는 컴픒레인이 들어와서
                        입력칸은 빈값으로 처리
                    
                    */
                    await this.$nextTick();
                    this.birthInputValue = '';
                    this.customerInfo.birth = null;
                    
                    // 시술일자 기본값을 오늘 날짜로 설정
                    const today = new Date();
                    const year = today.getFullYear();
                    const month = String(today.getMonth() + 1).padStart(2, '0');
                    const day = String(today.getDate()).padStart(2, '0');
                    const todayString = `${year}/${month}/${day}`;
                    this.customerInfo.surgeryDate = todayString;
                    this.surgeryInputValue = todayString;
                    this.uiHandler.getAgreements();
                    this.uiHandler.generateRules();
                    if(this.customerInfo.countryCode) {
                        this.tempCountryCode = this.customerInfo.countryCode;
                    }
                },
                /*
                
                data에 바로 선언하면 오류가 생김
                
                */
                generateRules: () => {
                    this.rules = {
                        email: [
                            {
                                required: this.sendChannel === commonEnum.sendChannel.EMAIL,
                                validator: this.validationHandler.validateEmail,
                                trigger: 'click'
                            }
                        ],
                        mobile: [],
                        name: [
                            {
                                required: true,
                                validator: this.validationHandler.validateName,
                                trigger: 'click'
                            }
                        ],
                        gender: [
                            {
                                required: true,
                                validator: this.validationHandler.validateGender,
                                trigger: 'click'
                            }
                        ],
                        birth: [
                            {
                                required: true,
                                validator: this.validationHandler.validateBirth,
                                trigger: 'click'
                            }
                        ],
                        surgeryDate: [
                            {
                                required: false,
                                validator: this.validationHandler.validatesurgeryDate,
                                trigger: 'click'
                            }
                        ],
                    }
                },
                modalHandler: (modalType, action) => {
                    if(!this.modals[modalType]) return;
                    this.modals[modalType].show = action;
                },
                handleSendChannelChange: async (value) => {
                    if(value === commonEnum.sendChannel.WECHAT) {
                        if(this.customerInfo.mobile === '010') {
                            this.customerInfo.mobile = '';
                        }
                        this.customerInfo.countryCode = '+86';
                        this.uiHandler.handleLanguageChange(commonEnum.language.ZH);
                        await this.$nextTick();
                    } else if(value === commonEnum.sendChannel.EMAIL) {
                        // 이메일 채널에서도 한국 번호 유지
                        this.customerInfo.countryCode = '+82';
                        this.uiHandler.handleLanguageChange(commonEnum.language.EN);
                        await this.$nextTick();
                    } else if(value === commonEnum.sendChannel.KAKAOTALK) {
                        this.customerInfo.countryCode = '+82';
                        if(this.customerInfo.mobile === '') {
                            this.customerInfo.mobile = '010';
                        }
                        this.uiHandler.handleLanguageChange(commonEnum.language.KO);
                    }
                    await this.$nextTick();
                    this.uiHandler.focusOnMobileInput();
                    this.$emit('update:sendChannel', value);
                },
                handleCountryCodeChange: async (value) => {
                    if(value === '+82' && this.customerInfo.mobile === '') {
                        this.customerInfo.mobile = '010';
                        const ele = document.getElementById('phone-number-input');
                        if(ele) ele.focus();
                    } else if(value !== '+82' && this.customerInfo.mobile === '010') {
                        this.customerInfo.mobile = '';
                        const ele = document.getElementById('phone-number-input');
                        if(ele) ele.focus();
                    }
                    if(value !== 'ETC') {
                        this.tempCountryCode = value;
                    }

                    if(value === 'ETC') {
                        this.uiHandler.modalHandler('countryCodeModal', true);
                    }

                    await this.uiHandler.processCustomerInfo();
                },
                handleEmitCountryCode: (value) => {
                    this.customerInfo.countryCode = value;
                    this.uiHandler.modalHandler('countryCodeModal', false);
                },
                handleLanguageChange: async (value) => {
                    this.$emit('update:language', value);
                },
                handleDoctorChange: (value) => {
                    this.customerInfo.doctor = value;
                },
                handleCustomDoctorChange: (value) => {
                    this.$emit('update:isCustomDoctor', value);
                },
                handleAgreementsChange :(updatedAgreements) => {
                    this.agreements = updatedAgreements;
                    this.customerInfo.agreements = updatedAgreements;
                },
                emitCustomerInfo: () => {
                    const customerInfo = { ...this.customerInfo };
                    
                    customerInfo.doctorName = this.hasCustomDoctorName ? this.customDoctorName : this.doctorName;
                    customerInfo.agreements = this.customerInfo.agreements;
                    customerInfo.ongoingSurgeries = this.customerInfo.ongoingSurgeries;

                    this.$emit('update:modelValue', customerInfo);
                    this.$emit('update:customerInfo', customerInfo);
                },
                handleCustomerInfoChange: (field, value, formatFunc = null) => {
                    if (formatFunc) {
                        value = formatFunc(value);
                    }
                    const updatedInfo = {
                        ...this.customerInfo,
                        [field]: value
                    };
                    this.customerInfo = updatedInfo; 
                },
                getCustomerListByName: async (input) => {
                    try {
                        const obj = {
                            text: input,
                        }; 
                        const result = await this.commonApiHandler.getCustomerListByName(obj);
                        if (Array.isArray(result)) {
                            this.nameDropBoxData = result;
                        }
                    } catch (error) {
                        console.error('Failed to get customer list by name:', error);
                    }   
                },
                handleInputCustomerName: (event) => {
                    this.customerInfo.name = event.target.value;
                },
                handleOnChangeCustomerNameInfo: async (info, event) => {
                    this.customerInfo.name = this.nameDropBoxData[event.key].name;
                    // 이메일 채널이 아닐 때만 mobile 설정
                    if (this.sendChannel !== commonEnum.sendChannel.EMAIL) {
                        this.customerInfo.mobile = this.formatHandler.phoneNumberFormatter(this.nameDropBoxData[event.key].mobile);
                    }
                    // 이메일 채널일 때는 email 필드 설정
                    if (this.sendChannel === commonEnum.sendChannel.EMAIL && this.nameDropBoxData[event.key].email) {
                        this.customerInfo.email = this.nameDropBoxData[event.key].email;
                    }
                    this.nameDropBoxData = this.nameDropBoxData.map(i=>{
                        return {
                            ...i,
                            text:i.name
                        }
                    })
                    await this.uiHandler.processCustomerInfo();
                },
                handleCustomerMobileChange: async (event) => {
                    const customerMobile = this.formatHandler.phoneNumberFormatter(event.target.value);
                    this.customerInfo.mobile = customerMobile;
                    if(this.customerInfo.countryCode === '+82' && this.customerInfo.mobile.length < 12) return;
                    if(this.customerInfo.countryCode !== '+82' && this.customerInfo.mobile.length < 8) return;
                    await this.uiHandler.processCustomerInfo();
                },
                handleCustomerEmailChange: async (event) => {
                    const email = event.target.value;
                    this.customerInfo.email = email;
                    // 이메일 채널에서는 전화번호가 있을 때만 고객 정보 조회
                    // 이메일 입력만으로는 조회하지 않음
                },
                handleChartNumberChange: (event) => {
                    this.customerInfo.chartNumber = event.target.value;
                },
                processCustomerInfo: async () => {
                    // 전화번호가 없으면 조회하지 않음
                    if (!this.customerInfo.mobile || this.customerInfo.mobile.trim() === '') {
                        return;
                    }
                    
                    const _convertedCustomerMobile = () => {
                        if(this.sendChannel === commonEnum.sendChannel.KAKAOTALK) {
                            if(this.customerInfo.countryCode === '+82') {
                                // 한국 번호는 하이픈 포함된 원본 형식 유지
                                return this.customerInfo.mobile;
                            } else {
                                // 다른 국가 번호는 하이픈, 공백 제거하고 국가 코드 추가
                                const cleanedNumber = this.customerInfo.mobile.replace(/[\s\-]/g, '');
                                const numberWithoutZero = cleanedNumber.startsWith('0') 
                                    ? cleanedNumber.slice(1) 
                                    : cleanedNumber;
                                return this.customerInfo.countryCode.replace('+', '') + numberWithoutZero;
                            }
                        } else if(this.sendChannel === commonEnum.sendChannel.WECHAT) {
                            // WeChat은 원본 번호 그대로 반환
                            return this.customerInfo.mobile;
                        } else {
                            // 기본적값으로 원본 번호 반환
                            return this.customerInfo.mobile;
                        }
                    }

                    try {
                        // 모든 채널에서 전화번호로 조회 (이메일 채널 포함)
                        const customerInfo = await this.commonApiHandler.getCustomerInfoByMobileAndSendChannel(_convertedCustomerMobile(), this.sendChannel);
                        // 기존 agreements에 isChecked 속성 추가 및 업데이트
                        const updatedAgreements = this.agreements.map(agreement => {
                            const isChecked = customerInfo.agreements.some(
                                customerAgreement => customerAgreement.agreementId === agreement._id
                            );
                            return { ...agreement, isChecked };
                        });

                        // customerInfo.agreements 업데이트
                        const checkedAgreementIds = updatedAgreements
                            .filter(agreement => agreement.isChecked)
                            .map(agreement => agreement._id);

                        /*
                        
                        스프레드연산자로 기존 내용 복사 후 필요한 값만 업데이트
                        try 내부에서는 mobile, surgeryDate 업데이트 불필요
                        
                        */

                        const newCustomerInfo = {
                            ...this.customerInfo,
                            id: customerInfo._id,
                            name: customerInfo.name || '',
                            birth: customerInfo.birth || null,
                            teethNos: customerInfo.teethNos || [],
                            gender: customerInfo.gender || '',
                            agreements: checkedAgreementIds,
                            ongoingSurgeries: customerInfo.ongoingSurgeries || [],
                        };

                        this.customerInfo = newCustomerInfo;
                        if(newCustomerInfo.mobile !== '010' && newCustomerInfo.name) {
                            this.uiHandler.updateCanLeaveStatus(false);
                        } else {
                            this.uiHandler.updateCanLeaveStatus(true);
                        }

                        this.uiHandler.focusOnNextStepButton();
                        // agreements 상태 업데이트
                        this.agreements = updatedAgreements;
                        
                        this.$emit('update:customerInfo', newCustomerInfo);
                        // TODO:확인버튼 포커싱
                    } catch (error) {
                        console.log(error);
                        // 404 에러일 때만 초기화 (신규 고객)
                        if (error.response?.status === 404) {
                            this.customerInfo = {
                                ...this.customerInfo,
                                id: '',
                                name: '',
                                birth: null,
                                teethNos: [],
                                gender: '',
                            };
                            this.birthInputValue = '';
                            
                            // 13자리 완성된 경우에만 이름 입력으로 포커스
                            // 홍콩이나 싱가포르는 8자리 휴대폰번호라 함. 자릿수가 유동적이므로 한국일 때만 처리
                            if(this.customerInfo.countryCode === '+82' && this.customerInfo.mobile.length === 13) {
                                this.uiHandler.focusOnNameInput();
                            }
                        }
                    }
                },
                focusOnNextStepButton: () => {
                    this.$emit('focus-on-next-step-button');
                },
                focusOnMobileInput: () => {
                    // 이메일 채널인 경우 emailInput에 먼저 포커스, 그 외는 mobileInput에 포커스
                    if(this.sendChannel === commonEnum.sendChannel.EMAIL && this.$refs.emailInput) {
                        this.$refs.emailInput.focus();
                    } else if(this.$refs.mobileInput) {
                        this.$refs.mobileInput.focus();
                    }
                },
                focusOnNameInput: () => {
                    this.$refs.nameInput.focus();
                },
                getAgreements: async () => {
                    const agreements = await this.commonApiHandler.getAgreements();
                    this.agreements = agreements.map(agreement => ({
                        ...agreement,
                        isChecked: false
                    }));
                },
                updateCanLeaveStatus: (value) => {
                    this.$emit('update:canLeavePage', value);
                },

                /*
                
                달력 인터랙션 관련 기능들
                
                */
                handleBirthYearClick: (year) => {
                    if(!year) return;

                    const { newDate, newFormattedDate } = this.issueUtils.handleYear(this.customerInfo.birth, this.birthInputValue, year);

                    this.customerInfo.birth = newDate;
                    this.birthInputValue = newFormattedDate;             
                },
                handleBirthMonthClick: (month) => {
                    if(!month || !this.customerInfo.birth) return;

                    const { newDate, newFormattedDate } = this.issueUtils.handleMonth(this.customerInfo.birth, this.birthInputValue, month);

                    this.customerInfo.birth = newDate;
                    this.birthInputValue = newFormattedDate;             
                },
                checkBirthYearSelected: (year) => {
                    return this.issueUtils.checkIsYearSelected(year, this.customerInfo.birth);
                },
                checkBirthMonthSelected: (month) => {
                    return this.issueUtils.checkIsMonthSelected(month, this.customerInfo.birth);
                },
                checkSurgeryYearSelected: (year) => {
                    return this.issueUtils.checkIsYearSelected(year, this.customerInfo.surgeryDate);
                },
                checkSurgeryMonthSelected: (month) => {
                    return this.issueUtils.checkIsMonthSelected(month, this.customerInfo.surgeryDate);
                },
                handleSurgeryYearClick: (year) => {
                    if(!year) return;

                    const { newDate, newFormattedDate } = this.issueUtils.handleYear(this.customerInfo.surgeryDate, this.surgeryInputValue, year);

                    this.customerInfo.surgeryDate = newDate;
                    this.surgeryInputValue = newFormattedDate;             
                },               
                handleSurgeryMonthClick: (month) => {
                    if(!month || !this.customerInfo.surgeryDate) return;

                    const { newDate, newFormattedDate } = this.issueUtils.handleMonth(this.customerInfo.surgeryDate, this.surgeryInputValue, month);

                    this.customerInfo.surgeryDate = newDate;
                    this.surgeryInputValue = newFormattedDate;             
                    this.uiHandler.scrollToSelectedSurgeryMonth();
                },
                scrollToSelectedBirthYear: () => {
                    const selectedYear = this.issueUtils.getSelectedDatePart(this.customerInfo.birth, 'year');
                    if (!selectedYear) return;
                    const yearEl = document.querySelector(`#birth-year-${selectedYear}`);
                    if (!yearEl) return;
                    const container = document.querySelector('.birth-year-wrap');
                    const containerHeight = container.clientHeight;
                    const elementHeight = yearEl.clientHeight;
                    container.scrollTop = yearEl.offsetTop - container.offsetTop + (elementHeight / 2) - (containerHeight / 2);
                },
                scrollToSelectedBirthMonth: () => {
                    const selectedMonth = this.issueUtils.getSelectedDatePart(this.customerInfo.birth, 'month');
                    if (!selectedMonth) return;
                    const monthEl = document.querySelector(`#birth-month-${selectedMonth}`);
                    if (!monthEl) return;
                    const container = document.querySelector('.birth-month-wrap');
                    const containerHeight = container.clientHeight;
                    const elementHeight = monthEl.clientHeight;
                    container.scrollTop = monthEl.offsetTop - container.offsetTop + (elementHeight / 2) - (containerHeight / 2);
                },
                scrollToSelectedSurgeryYear: () => {
                    const selectedYear = this.issueUtils.getSelectedDatePart(this.customerInfo.surgeryDate, 'year');
                    if (!selectedYear) return;
                    const yearEl = document.querySelector(`#surgery-year-${selectedYear}`);
                    if (!yearEl) return;
                    const container = document.querySelector('.surgery-year-wrap');
                    const containerHeight = container.clientHeight;
                    const elementHeight = yearEl.clientHeight;
                    container.scrollTop = yearEl.offsetTop - container.offsetTop + (elementHeight / 2) - (containerHeight / 2);
                },
                scrollToSelectedSurgeryMonth: () => {
                    const selectedMonth = this.issueUtils.getSelectedDatePart(this.customerInfo.surgeryDate, 'month');
                    if (!selectedMonth) return;
                    const monthEl = document.querySelector(`#surgery-month-${selectedMonth}`);
                    if (!monthEl) return;
                    const container = document.querySelector('.surgery-month-wrap');
                    const containerHeight = container.clientHeight;
                    const elementHeight = monthEl.clientHeight;
                    container.scrollTop = monthEl.offsetTop - container.offsetTop + (elementHeight / 2) - (containerHeight / 2);
                },            
                generateYearAndMonths: () => {
                    const currentYear = dayjs().year();       
                    for(let i = 1900; i <= currentYear; i++) {
                        this.yearList.push(i);
                    }
                    for(let i = 1; i <= 12; i++) {
                        this.monthList.push(i);
                    }
                },
            }
        },
        createValidationHandler() {
            return {
                validateEmail: async (_rule, value) => {
                    // 이메일 채널인 경우에만 이메일 검증
                    if (this.sendChannel === commonEnum.sendChannel.EMAIL) {
                        const email = this.customerInfo.email?.trim();
                        if (!email) {
                            await oneBtnDialog(this.$t('workorder_validation_email_required_title'), this.$t('workorder_validation_email_required_message'), false, this.$t('workorder_validation_confirm'));
                            return Promise.reject(new Error(this.$t('workorder_validation_email_required_message')));
                        }

                        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                        if (!emailRegex.test(email)) {
                            await oneBtnDialog(this.$t('workorder_validation_email_invalid_title'), this.$t('workorder_validation_email_invalid_message'), false, this.$t('workorder_validation_confirm'));
                            return Promise.reject(new Error(this.$t('workorder_validation_email_invalid_message')));
                        }
                    }
                    return Promise.resolve();
                },
                validateMobile: async (_rule, value) => {
                    // 전화번호는 항상 필수로 검증
                    this.customerInfo.mobile = this.customerInfo.mobile.trim();

                    if (!value) {
                        await oneBtnDialog(this.$t('workorder_validation_mobile_required_title'), this.$t('workorder_validation_mobile_required_message'), false, this.$t('workorder_validation_confirm'));
                        return Promise.reject(new Error(this.$t('workorder_validation_mobile_required_message')));
                    }

                    return Promise.resolve();
                },
                validateName: async (_rule, value) => {
                    this.customerInfo.name = this.customerInfo.name.trim();
                    if (!value) {
                        await oneBtnDialog(this.$t('workorder_validation_name_required_title'), this.$t('workorder_validation_name_required_message'), false, this.$t('workorder_validation_confirm'));
                        return Promise.reject(new Error(this.$t('workorder_validation_name_required_message')));
                    }
                    return Promise.resolve();
                },
                validateGender: async (_rule, value) => {
                    return Promise.resolve();
                },
                validateBirth: async (_rule, value) => {
                    // customerInfo.birth는 date타입이므로 스트링 값에 대한 비교가 필요
                    if (this.birthInputValue && this.birthInputValue.length < 10) {
                        await oneBtnDialog(this.$t('workorder_validation_birthdate_error_title'), this.$t('workorder_validation_birthdate_error_message'), false, this.$t('workorder_validation_confirm'));
                        return Promise.reject(new Error(this.$t('workorder_validation_birthdate_error_message')));
                    }

                    if (this.birthInputValue && this.birthInputValue === 'Invalid Date') {
                        await oneBtnDialog(this.$t('workorder_validation_birthdate_error_title'), this.$t('workorder_validation_birthdate_error_message'), false, this.$t('workorder_validation_confirm'));
                        return Promise.reject(new Error(this.$t('workorder_validation_birthdate_error_message')));
                    }

                    return Promise.resolve();
                },

                validatesurgeryDate: async (_rule, value) => {
                    // 시술일자는 선택사항이므로 값이 없으면 통과
                    if (!value) {
                        return Promise.resolve();
                    }
                    if(this.surgeryInputValue === 'Invalid Date') {
                        await oneBtnDialog(this.$t('workorder_validation_surgery_date_error_title'), this.$t('workorder_validation_surgery_date_error_message'), false, this.$t('workorder_validation_confirm'));
                        return Promise.reject(new Error(this.$t('workorder_validation_surgery_date_error_message')));
                    }

                    if (this.surgeryInputValue.length < 10) {
                        await oneBtnDialog(this.$t('workorder_validation_surgery_date_error_title'), this.$t('workorder_validation_surgery_date_error_message'), false, this.$t('workorder_validation_confirm'));
                        return Promise.reject(new Error(this.$t('workorder_validation_surgery_date_error_message')));
                    }
                    if (dayjs(this.customerInfo.birth) > dayjs(value)) {
                        await oneBtnDialog(this.$t('workorder_validation_surgery_date_error_title'), this.$t('workorder_validation_surgery_date_before_birth'), false, this.$t('workorder_validation_confirm'));
                        return Promise.reject(new Error(this.$t('workorder_validation_surgery_date_before_birth')));
                    }
                    return Promise.resolve();
                },
                validateData: async () => {
                    try {
                        await this.$refs.formRef.validateFields(['name']);
                    } catch (validationError) {
                        return;
                    }

                    try {
                        await this.$refs.formRef.validateFields(['birth']);
                    } catch (validationError) {
                        return;
                    }

                    try {
                        await this.$refs.formRef.validateFields(['surgeryDate']);
                    } catch (validationError) {
                        return;
                    }

                    // const hasUncheckedItem = this.agreements.some(obj => !obj.isChecked);
                    // if (hasUncheckedItem) {
                    //     await oneBtnDialog(
                    //     '약관 미동의',
                    //     '약관에 전부 동의해 주세요.',
                    //     false,
                    //     '확인'
                    //     );
                    //     return;
                    // }

                    try {
                        await this.$refs.formRef.validate();
                        this.uiHandler.emitCustomerInfo();

                        return true;
                    } catch (error) {
                        console.error('Validation failed:', error);
                        return false;
                    }
                },
            }
        },
        createApiHandler() {
            return {
                common: () => {
                    return issueCertificateCommonApis(this.$apiInstance, this.$store);
                }
            }
        },
    }
}
</script>
<style lang="scss">
    @import './css/date-picker.scss';
    
    .whole-step-container {
        .dp__input_wrap {
            display: none;
        }
        .dp__outer_menu_wrap {
            width: 100%;
            margin-top: 10px;
        }
        .date-picker-wrap.issue .dp__menu {
            border: none;
        }
        .date-picker-wrap.issue .dp__calendar_header_separator {
            display: none;
        }
         .ant-form-item{
             margin-bottom: 0px;
         }
    }
    
    .mobile-input-wrap {
        display: flex;
        gap: 4px;
        .select-country-code {
            width: 130px;
        }
        .zh-icon-round {
            width: 25px;
            height: 25px;
        }
        #phone-number-input {
            width: 100px;
            flex: 1;
        }
    }

    .select-option-containers {
        display: flex;
        gap: 8px;
    }
    
</style>
<style scoped lang="scss">
@import './css/issue-certificate.scss';
@import './css/implant-abutment.scss'; 
</style>